import { Button, MenuItem, MenuTrigger } from '@eleveo/components-react';
import { BinIcon, PencilIcon, ThreeDotsIcon } from '@eleveo/icons-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { getSkillPropTag } from './constants';
import { SkillWithUsed } from '../../graphql/components';

export interface TableActionsMenuProps {
  onDeleteSkill: (s: SkillWithUsed) => void;
  onEditSkill: (s: SkillWithUsed) => void;
  hasDeletePermission: boolean;
  hasEditPermission: boolean;
  skillItem: SkillWithUsed;
}

export const TableActionsMenu: React.FC<TableActionsMenuProps> = ({
  onDeleteSkill,
  onEditSkill,
  hasDeletePermission,
  hasEditPermission,
  skillItem,
}) => {
  const { t } = useTranslation();

  const noPermission = !hasEditPermission && !hasDeletePermission;

  const handleEdit = (s: SkillWithUsed) => () => onEditSkill(s);
  const handleDelete = (s: SkillWithUsed) => () => onDeleteSkill(s);

  const menuItems: MenuItem[] = [];

  if (hasEditPermission) {
    menuItems.push({
      icon: <PencilIcon />,
      id: '1',
      onClick: handleEdit(skillItem),
      testId: getSkillPropTag('edit'),
      text: t('layout.action.edit'),
    });
  }

  if (hasDeletePermission) {
    menuItems.push({
      icon: <BinIcon />,
      id: '2',
      isDisabled: skillItem.used,
      onClick: handleDelete(skillItem),
      testId: getSkillPropTag('delete'),
      text: t('layout.action.delete'),
    });
  }

  return (
    <MenuTrigger items={menuItems}>
      <Button
        aria-label={t('layout.action.actions')}
        isDisabled={noPermission}
        isSmall
        testId={getSkillPropTag('actions')}
        variant="quiet"
      >
        <ThreeDotsIcon />
      </Button>
    </MenuTrigger>
  );
};
